import CKEditorContent from '../CKEditorContent/CKEditorContent'
import styled, { css } from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { deviceMax } from '../../theme/breakpoints'
import CardModal from '../CardModal/CardModal'
import Button from '../Button/Button'
import Download from '../../images/icons/download.svg'

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  width: ${pxToRem(384)};
  height:  auto;
  padding: ${pxToRem(16)};
  border-radius: ${pxToRem(5)};
  gap: ${pxToRem(10)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  border: ${({ $isSelected, theme }) => $isSelected ? `${pxToRem(2)} solid ${theme.colors.primary.blue};`:'none'};
  box-shadow: ${({ $isSelected }) => $isSelected ? `0 0 ${pxToRem(10)} 0 #6E8C8E33;`:'none'};

  @media ${deviceMax.mobileL} {
    width: ${pxToRem(304)};
  }
  
`

export const StyledInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(12)};
`

export const StyledInfosImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: ${pxToRem(12)};
`

export const StyledTitle = styled.h2`
  max-width: ${pxToRem(352)};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  
  @media ${deviceMax.tablet} {
    margin-top: initial;
  }
`

export const StyledSubtitleContainer = styled.div`
  flex-direction: row-reverse;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: ${({ theme }) => theme.fonts.lineHeight.button};
  color: ${({ theme }) => theme.colors.opacity.black70};
  @media ${deviceMax.tablet} {
    flex-wrap: initial;
    align-items: center;
  }
`

export const StyledMedia = styled.div`
  border-radius: 0 0 ${pxToRem(30)} 0;
  height: ${pxToRem(205)};
  width: ${pxToRem(352)};
  cursor: pointer;
 
  img,
  video,
  iframe {
    pointer-events: none;
    height: ${pxToRem(205)};
    width: 100%;
    object-fit: cover;
    border-radius: ${pxToRem(0)} ${pxToRem(0)} ${pxToRem(30)} ${pxToRem(0)};
  }

  @media ${deviceMax.mobileL} {
    width: 100%;
  }
`

const styledTitles = css`
  max-width: ${pxToRem(352)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media ${deviceMax.tablet} {
    max-width: none;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`

export const StyledSubtitle = styled.h3`
  ${styledTitles}
`

export const StyledSubtitleVideo = styled.p`
  max-width: ${pxToRem(352)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  color: ${({ theme }) => theme.colors.primary.grey};
`

export const StyledSubtitleText = styled.p`
  ${styledTitles}
`

export const StyledMobileDescription = styled.div`
  flex-direction: column;
  display: flex;
  width: calc(100% - ${pxToRem(80)});
`
export const StyledCKEditorContent = styled(CKEditorContent)`
  @media ${deviceMax.tablet} {
    margin: 0 ${pxToRem(20)};
  }
`

export const StyledCardModal = styled(CardModal)`
  display: ${({ isDisplay }) => (isDisplay ? 'flex' : 'none')};
`

export const StyledButton = styled(Button)`
  padding: ${pxToRem(2)};
  border: ${({ theme }) => `${pxToRem(1)} solid ${theme.colors.unique.black}`};
  cursor: pointer;
  
  &:hover {
    border: ${({ theme }) => `${pxToRem(1)} solid ${theme.colors.unique.black}`};
    background-color: transparent;
  } 
`

export const StyledIcon = styled(Download)`
  color: ${({ theme }) => theme.colors.unique.black};
`

export const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${pxToRem(2)};
`